
function formatUser(user, securityCodes = {}) {
 return {
    "id": user._id,
    "cellphone": user.celular,
    "active": user.ativo,
    "name": user.nome,
    "profile": user.perfil,
    "code": securityCodes[user.celular] || null
 }
}

function formatUsers(users, securityCodes) {
  const result = {}
  users.forEach((user) => {
    result[user._id] =  formatUser(user, securityCodes)
  })

  return result
}


export const formatResponses = {
  formatUser: (user) => formatUser(user),
  formatUsers: (users) => formatUsers(users),
  formatUsersWithSecurityCode: (users,securityCodes) => formatUsers(users, securityCodes),
};
